import { Col, Row } from "reactstrap";

import CustomTooltip from "@components/ui-components/tooltip";
import Flex from "@components/ui-components/flex";
import ImageWrapper from "@components/ui-components/image-wrapper";
import { LoaderOverlay } from "@components/spinner";
import PropTypes from "prop-types";
import classnames from "classnames";
import size from "lodash/size";
import { useTranslation } from "react-i18next";

const FormView = props => {
    const {
        content = [],
        title = "",
        desc = "",
        loading = false,
        extraContent = null,
        id = "",
        className = "padding-x-inherit"
    } = props;
    const { t } = useTranslation();
    const View = (item, index) => !item.hide && (
        <Row className="form-view-bg border mb-2 g-0 p-1 rounded" key={index}>
            {item.leftChild && (
                <Col
                    {...(item.leftChildProps || { lg: "4" })}
                    className="pe-2">
                    <Flex
                        column
                        align="start"
                        justify="start"
                        className="h-100">
                        <span
                            className="font-medium-1 fw-bolder mb-25"
                            data-cy="title">
                            {" "}
                            {t(item.leftChild.title)}
                            {item.leftChild.tooltip ? (
                                <>
                                    {" "}
                                    <ImageWrapper
                                        src={"common/info-circle.svg"}
                                        className="ms-75"
                                        id={item.leftChild.title.replace(
                                            /\s/g,
                                            ""
                                        )}/>
                                    <CustomTooltip
                                        target={item.leftChild.title.replace(
                                            /\s/g,
                                            ""
                                        )}
                                        content={item.leftChild.tooltip}/>
                                </>
                            ) : null}
                        </span>
                        {item.leftChild.desc && (
                            <span
                                className="font-small-4 mt-25 text-muted"
                                data-cy="desc">
                                {" "}
                                {typeof item.leftChild.desc === "string" ? t(item.leftChild.desc) : item.leftChild.desc}
                            </span>
                        )}
                        {item.leftChild.extraContent}
                    </Flex>
                </Col>
            )}
            {item.rightChild && (
                <Col
                    {...(item.rightChildProps || { lg: "8" })}
                    data-tour={item.id}>
                    {item.rightChild}
                </Col>
            )}
        </Row>
    );
    return (
        <LoaderOverlay
            active={loading}
            children={
                <div className={classnames(className)}>
                    {title ? (
                        <p
                            className="font-medium-1 fw-bolder mb-25"
                            data-cy="title">
                            {" "}
                            {t(title)}
                        </p>
                    ) : null}
                    {desc ? (
                        <p
                            className="font-small-5 text-muted mb-25"
                            data-cy="desc">
                            {" "}
                            {t(desc)}
                        </p>
                    ) : null}
                    {extraContent && extraContent}
                    <div data-tour={id}>
                        {size(content) ? content.map((item, index) => (!item.omit ? View(item, index) : null)
                        ) : View(props, 0)}
                    </div>
                </div>
            }/>
    );
};

FormView.propTypes = {
    id             : PropTypes.string,
    leftChild      : PropTypes.any,
    leftChildProps : PropTypes.any,
    rightChildProps: PropTypes.any,
    rightChild     : PropTypes.node,
    className      : PropTypes.string,
    title          : PropTypes.string,
    desc           : PropTypes.string,
    loading        : PropTypes.bool,
    extraContent   : PropTypes.any,
    content        : PropTypes.array
};

export default FormView;
